// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__twkrP","unreadBadge":"styles_unreadBadge__10Vir","modalContent":"styles_modalContent__3OlqG","modal":"styles_modal__3jeij"};